<template>
	<div class="flex flex-col items-center mt-4">
		<ContactUsGroup v-for="(group, index) in contacts" :key="index" :name="group.groupName">
			<ContactUsCard
				v-for="(member, index) in group.members"
				:key="index"
				:name="member.name"
				:role="member.role"
				:email="member.email"
				:phone="member.phone"
			/>
		</ContactUsGroup>
		<div class="flex flex-col items-center py-4">
			<span class="uppercase font-medium mb-2">{{ $t("contacts.companyDataHu.title") }}</span>
			<div class="text-center" v-html="$t('contacts.companyDataHu.data')"></div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
	name: "ContactUsHu",
	setup() {
		const { getEmail } = usePublicConfig();
		const contacts = computed(() => [
			{
				groupName: "customerService",
				members: [
					{
						name: "",
						role: "",
						email: getEmail("hello", "HU"),
						phone: "",
					},
				],
			},
			{
				groupName: "contacts",
				members: [
					{
						name: "Németh Rókus",
						role: "Head of Sales",
						email: "rokus.nemeth@dreamjobs.hu",
						phone: "+36 70 346 4330",
					},
				],
			},
			{
				groupName: "management",
				members: [
					{
						name: "Grüman Róbert",
						role: "vezérigazgató",
						email: "robert.gruman@mobilitygroup.hu",
						phone: "",
					},
				],
			},
			/*
			{
				groupName: "development",
				members: [
					{
						name: "",
						role: "",
						email: "",
						phone: "",
					},
				],
			},
			//*/
		]);

		return {
			contacts,
		};
	},
});
</script>
